"use client";

import TypingEffect from "@/components/ui/TypingEffect";

export default function HeroTyping() {
  return (
    <TypingEffect
      text={["whoami", "iamickdev", "Arnon S."]}
      infinite
      typingSpeed={1}
      colorClass="text-terminal-pink"
    />
  );
}